import { text } from "@fortawesome/fontawesome-svg-core";

export const COLORS = {
  primary: "#FFBD31",
  secondary: "#5C9B59",
  background: "#f6f6f6",
  surface: "#ffffff",
  error: "#b00020",
  text: "#000000",
  textLight: "#ffffff",
  textDark: "#333333",
  border: "#eeeeee",
  borderDark: "#dddddd",
  glowButtonBorder: "#755A08"
};
